$(document).ready(function () {
    const vanzFeatured = $(".js_vanzFeatured");

    if (vanzFeatured.length > 0) {

        vanzFeatured.slick({
            dots: false,
            infinite: false,
            arrows: true,
            autoplay: false,
            draggable: true,
            speed: 600,
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: true,
            prevArrow: '<button type="button" data-role="none" class="slick-prev postsArrow" aria-label="Previous" tabindex="0" role="button"><i class="fa fa-angle-left"></i></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next postsArrow" aria-label="Next" tabindex="0" role="button"><i class="fa fa-angle-right"></i></button>',
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        dots: false,
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 670,
                    settings: {
                        dots: false,
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
});